import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import HorizontalDivider from '../HorizontalDivider';
import {
  ArrowImg,
  ImageWrapper,
  RelatedProductsWrapper,
  SliderCell,
  SliderRow,
  Subtext,
  Title,
  ViewMore,
} from './RelatedProducts.css';
import withCountryCode from '../../../components/RoutesHoc/RoutesHoc';
import RelatedProductLink from './RelatedProductLink';

// TODO: refactor in functional component
class RelatedProducts extends Component {
  render() {
    const {
      brandUrl,
      brandName,
      currencySymbol,
      department,
      products,
      s3BasePath,
      buildUrlWithCountry,
      showSale = false,
    } = this.props;

    return (
      <RelatedProductsWrapper data-cy="products-related">
        <Title>More from {brandName}</Title>

        <HorizontalDivider />

        <Subtext>
          Slide to scroll
          <ArrowImg src={`${s3BasePath}mkt/icon/arrow_right_grey.png`} />
        </Subtext>

        <SliderRow>
          <>
            {products.map(product => (
              <SliderCell key={product.url}>
                <RelatedProductLink
                  currencySymbol={currencySymbol}
                  showSale={showSale}
                  product={product}
                  s3BasePath={s3BasePath}
                />
              </SliderCell>
            ))}
          </>
          <SliderCell key="view_more">
            <a id="more-brand" href={buildUrlWithCountry(brandUrl)}>
              <ImageWrapper>
                <ViewMore>
                  View more from
                  <span>{brandName}</span>
                </ViewMore>
              </ImageWrapper>
            </a>
          </SliderCell>
        </SliderRow>

        <HorizontalDivider />
      </RelatedProductsWrapper>
    );
  }
}
RelatedProducts.propTypes = {
  brandName: PropTypes.string.isRequired,
  brandUrl: PropTypes.string.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  department: PropTypes.string.isRequired,
  products: PropTypes.array.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  showSale: PropTypes.bool,
};

export default withCountryCode(RelatedProducts);
